/**
 * @param {import("axios").AxiosInstance} instance
 */

import { NO_PUC, DEFAULT_PUC } from 'constants/stringConstants'

export default function farms(instance) {
	return {
		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`farms${params}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('farms', body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (id, config = {}) => {
			return instance.get(`farms/${id}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getCommodities: (config = {}) => {
			return instance.get(`farms/commodities`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getCertifications: (config = {}) => {
			return instance.get(`farms/certifications`, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmCertifications: (id, config = {}) => {
			return instance.get(`farms/${id}/certifications`, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmCommodities: (id, config = {}) => {
			return instance.get(`farms/${id}/commodities`, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmDispatches: (id, config = {}) => {
			return instance.get(`farms/${id}/dispatches`, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFormsAndDevices: (config = {}) => {
			return instance.get(`farms/dispatches/create`, config)
		},
		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getCertificationStatuses: (config = {}) => {
			return instance.get(`farms/certifications/statuses`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		createFarmDispatch: (body, config = {}) => {
			return instance.post('farms/dispatches', body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		updateFarmDispatch: (id, body, config = {}) => {
			return instance.put(`farms/dispatches/${id}`, body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmDispatch: (id, config = {}) => {
			return instance.get(`farms/dispatches/${id}`, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		deleteDispatch: (id, config = {}) => {
			return instance.put(`farms/dispatches/${id}`, {}, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		updateFarmCertificate: (id, config = {}) => {
			return instance.put(`farms/certifications/${id}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		updateCommodity: (body, config = {}) => {
			return instance.put(`farms/commodities`, body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		createCertification: (body, config = {}) => {
			return instance.post('farms/certifications', body, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (body, config = {}) => {
			return instance.put('farms', body, config)
		},

		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`farms/${id}`, config)
		},

		/**
     * @param {number} farmId
	 * @param {number} certificateId

     * @param {import("axios").AxiosRequestConfig} config
     */
		deleteCertification: (farmId, certificateId, config = {}) => {
			const params =
				!!farmId && !!certificateId
					? `?farmId=${farmId}&farmCertificationId=${certificateId}`
					: ''

			return instance.delete(`farms/certifications${params}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		updateCertification: (body, config = {}) => {
			return instance.put('farms/certifications', body, config)
		},

		/**
		 * @param {number} name
		 * @param {string} puc
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, puc, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const farmParam = name ? `name=${name}&` : ''
			const pucParam = puc ? `puc=${puc === NO_PUC ? DEFAULT_PUC : puc}&` : ''

			return instance.get(`farms?${params}${farmParam}${pucParam}`, config)
		}
	}
}
